module.exports = __webpack_public_path__ + "static/Logo-03-ca9ac61fc01bc383e4b0792cfad3b769.png";